import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MasterService } from '../../../../services/master.service'
import { MessageService } from '../../../../services/message.service'
import * as languageLibrary from '../../../../services/language'
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { Subscription } from "rxjs";

@Component({
    selector: 'commission-corp',
    templateUrl: './commission-corp.component.html',
    styleUrls: ['./commission-corp.component.scss'],
    standalone: false
})
export class CommissionCorpComponent implements OnInit {
  /*
  * variables
  */
  //  
  @Input() isFlat: boolean = false

  //  implement contact object
  @Input() contact: Object = {}

  //  define if is individual
  protected isIndividual: boolean = false
  
  //  
  protected type = {}
  
  // save the language
  protected language: string = localStorage.getItem('language') ? localStorage.getItem('language') : 'EN'
  
  // set all words
  protected words = languageLibrary.language
  
  // define the selected address
  protected addressSelected: Object = { object: {}, index: 0 }
  
  // define the address selected
  protected selected: Object = { address: 'none' }
  
  // save all addresses
  protected addressesList: Object[] = []
  
  // save the types
  protected types: Object[] = [{ id: 1, name: 'Billing' }, { id: 2, name: 'Home' }, { id: 3, name: 'Mailing' }, { id: 4, name: 'Work' }]
  
  // save the rent or own
  protected rentOwn: string[] = ['Rent', 'Own', 'Other']
  
  // define if loading state
  protected loading: boolean = false
  
  // zip code list
  protected zipCodeList: Object[] = []
  
  // set time out
  private timeOutID: any;
  
  //  define if some changes not saved
  private savePending: boolean = false

  // A handle to navbar event messages so we can unsubscribe later.
  private navbarWatcher: Subscription | null = null

  // addresslokup
  private addressLookup: Object = {
    city: "",
    county: "",
    state: "",
    zipcode: "",
    country: ""
  }

  // Group of inputs
  private information = new FormGroup({
    contactId: new FormControl<string>('', [Validators.required]),
    addressTypeId: new FormControl<string>('', [Validators.required]),
    status: new FormControl<string>(''),
    address: new FormControl<string>('', [Validators.required]),
    address2: new FormControl<string>('', []),
    zipCode: new FormControl<string>('', [Validators.required, Validators.pattern('[0-9]{3,10}')]),
    city: new FormControl<string>('', [Validators.required]),
    state: new FormControl<string>('', [Validators.required]),
    county: new FormControl<string>('', [Validators.required]),
    country: new FormControl<string>('', [Validators.required]),
    startDate: new FormControl<string>(''),
    endDate: new FormControl<string>(''),
  })
  
  // 
  @Output() addresses$: EventEmitter<Object> = new EventEmitter()
  // get information of inputs
  get address() { return this.information.get('address') }
  get address2() { return this.information.get('address2') }
  get zipCode() { return this.information.get('zipCode') }
  get startDate() { return this.information.get('startDate') }
  get endDate() { return this.information.get('endDate') }

  /*
  * functions
  */
  // todo: detect changes
  private changesPending = () => {

    if (!this.savePending) {
      this.savePending = true
      this.ms.channelComponents$.emit({ message: 'changesPendingContacts', section: 'addresses', value: this.savePending })
    }
  }
  //  get data
  private getData = () => {
    this.master.post('readContactDetails', { contactId: this.contact['id'] }, res => {
      if (res) {
        if (res.status == 200) {
          // * success
          this.addressesList = res.data.contact[0]['addresses']
          if (this.addressesList.length > 0) {
            let object = this.addressesList.filter(el => el['primaryAddress'] == 1)
            if (object.length > 0) {
              this.selected = object[0]
            } else {
              this.selected = { address: 'none' }
            }
          }
        } else {
          // ! send message in case error 
          this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
        }
      } else {
        // in case API no response
        this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
      }

    })
  }

  // clean Fields
  private cleanFields = (): void => {

    this.addressSelected = { object: {}, index: 0 }
    this.zipCodeList = []
    this.information.reset()

    this.information.setValue({
      contactId: this.contact['id'],
      addressTypeId: '',
      status: '',
      address: '',

      address2: '',
      zipCode: '',
      city: '',

      state: '',
      county: '',
      country: '',

      startDate: '',
      endDate: ''
    })
  }
  /*
  ?: create
  */
  // save
  private save = (afterClose): void => {
    if (this.information.valid) {
      this.loading = true
      // check the end date value
      // let endDate
      // * date success
      let object = { ...this.information.value }
      object['addressTypeId'] = this.information.value['addressTypeId']
      // set hour
      object['startDate'] == "" ? object['startDate'] = null : object['startDate'] = object['startDate'] + ' 00:00:00'
      object['endDate'] == "" ? object['endDate'] = null : object['endDate'] = object['endDate'] + ' 00:00:00'
      this.isIndividual ? object['status'] : object['status'] = "Other"

      // check if start date is before to end date
      if (object['startDate'] && object['endDate']) {
        if (moment(object['startDate']) >= moment(object['endDate'])) {
          this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['startDateOrEndDateInvalid'] });
          this.loading = false
          return
        }
      }
      if (this.contact['isIndividual'] === 0) {
        object['status'] = "Other"
      }
      //  save address
      this.master.post('createContactAddress', { addresses: [object] }, res => {
        // set loading state
        this.loading = false
        if (res) {
          if (res.status == 200) {
            this.addresses$.emit({})
            // * success
            this.savePending = false
            this.ms.channelComponents$.emit({ message: 'changesPendingContacts', section: 'addresses', value: this.savePending })
            if (afterClose && !this.isFlat) {
              // close modal

              this.ms.channelComponents$.emit({ message: 'reloadContactDetail', section: 'addresses', value: null });
              (document.getElementById('btn-cancel-addresses') as HTMLButtonElement).click();
            }
            // recharge user data
            this.getData()
            // clean the fields
            this.cleanFields()
            // send message
            this.ms.sendMessage("alert", { type: "success", text: this.words[this.language]['success'] });
          } else {
            // ! send message in case error 
            this.ms.sendMessage("alert", { type: "danger", text: res.data.error });

          }
        } else {
          // in case API no response
          this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });

        }
      })
    }

  }

  /*
  todo: update
  */
  // save
  private update = (): void => {
    if (this.information.valid) {
      // * date success
      let objectChanged = { ...this.information.value }
      this.loading = true
      if (this.contact['isIndividual'] === 0) {
        objectChanged['status'] = "Other"
      }
      objectChanged['addressTypeId'] = this.information.value['addressTypeId']
      objectChanged['addressId'] = this.addressSelected['object']['id']
      // set format date
      objectChanged['endDate'] == null || objectChanged['endDate'] == "Invalid date" ? objectChanged['endDate'] = null : objectChanged['endDate'] = objectChanged['endDate'] + ' 00:00:00'
      objectChanged['startDate'] == null || objectChanged['startDate'] == "Invalid date" ? objectChanged['startDate'] = null : objectChanged['startDate'] = objectChanged['startDate'] + ' 00:00:00'
      // check if start date is before to end date
      if (objectChanged['startDate'] && objectChanged['endDate']) {
        if (moment(objectChanged['startDate']) >= moment(objectChanged['endDate'])) {
          this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['startDateOrEndDateInvalid'] });
          this.loading = false
          return
        }
      }
      //  save address
      this.master.post('modifyContactAddress', objectChanged, res => {
        // set loading state
        this.loading = false
        if (res) {
          if (res.status == 200) {
            // * success
            if (!this.isFlat) {
              // recharge user data
              this.ms.channelComponents$.emit({ message: 'reloadContactDetail', section: 'addresses', value: null });
            }
            this.getData()
            // close modal
            if (!this.isFlat) {
              (document.getElementById('btn-close-addresses-update') as HTMLButtonElement).click();
            }
            // clean the fields
            this.cleanFields()
            // send message
            if (this.addressSelected['object']['primaryAddress'] == 1) {
              // in case default address
              this.ms.sendMessage("alert", { type: "success", text: this.words[this.language]['success'] });
            } else {
              // in another case
              this.ms.sendMessage("alert", { type: "success", text: res.data.message });
            }
          } else {
            // ! send message in case error 
            this.ms.sendMessage("alert", { type: "danger", text: res.data.error });

          }
        } else {
          // in case API no response
          this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });

        }
      })
    } else {
      // ! start date  invalid
      this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['startDateOrEndDateInvalid'] });
    }


  }
  // select address update
  private selectAddressUpdate = (address: Object): void => {
    this.addressSelected['object'] = address
    
    this.information.setValue({
      contactId: this.contact['id'],
      addressTypeId: address['addressTypeId'],
      status: address['status'],
      address: address['address'],
      address2: address['address2'],
      zipCode: address['zipCode'],
      city: address['city'],
      state: address['state'],
      county: address['county'],
      country: address['country'],
      startDate: address['startDate'] == null || address['startDate'] == 'Invalid date' ? "" : address['startDate'],
      endDate: address['endDate'] == null || address['endDate'] == 'Invalid date' ? "" : address['endDate'],
    })
    
  }
  /*
  ! delete
  */
  // select address
  private selectAddress = (address: Object, index: number): void => {
    this.addressSelected['object'] = address
    this.addressSelected['index'] = index
  }
  
  /*
  ! delete
  */
  private delete = (): void => {
    this.loading = true
    this.master.discard(`deleteContactAttributes?polimorphEntity=address&polimorphId=${this.addressSelected['object'].id}`, res => {
      this.loading = false
      if (res) {
        if (res.status == 200) {
          // * success
          if (!this.isFlat) {
            (document.getElementById('close-delete-modal') as HTMLButtonElement).click();
          }
          this.ms.sendMessage("alert", { type: "success", text: this.words[this.language]['success'] });
          
          if (this.addressSelected['object']['primaryAddress'] == 1) {
            // assign the new address, in case address primary was deleted
            let address = this.addressesList.filter(el => el['primaryAddress'] == 0)
            if (address.length > 0) {
              this.selectDefault(address[0])
            } else {
              this.selected = { address: 'none' }
            }
          }
          // delete from array
          this.addressesList.splice(this.addressSelected['index'], 1)
          this.cleanFields()
        } else {
          // ! send message in case error 
          this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
          this.loading = false
        }
      } else {
        // in case API no response
        this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
        this.loading = false
      }
    })
  }
  // todo:alert quest delete
  private questDelete = (address: Object, index: number) => {
    if (confirm(this.words[this.language]['deleteAddress'])) {
      this.selectAddress(address, index)
      this.delete()
    }
  }
  /*
 * select defaul
 */
  // define the address default
  private selectDefault = (address: Object): void => {
    this.master.patch(`/contacts/${this.contact['id']}/addresses/${address['id']}/primary`, {}, res => {
      this.loading = false
      if (res) {
        if (res.status == 200) {
          // * success
          // reload all to false
          this.addressesList.map(el => el['primaryAddress'] = 0)
          // set new default
          address['primaryAddress'] = 1
          this.selected = address
          // send message
          this.ms.sendMessage("alert", { type: "success", text: this.words[this.language]['success'] });
        } else {
          // ! send message in case error 
          this.ms.sendMessage("alert", { type: "danger", text: res.data.error });

        }
      } else {
        // in case API no response
        this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
      }
    })
  }

  // ? address loockup
  // verify if the corporate is already exist
  private searchZipCode(): void {

    if (this.addressLookup['zipcode'].length < 3) {
      return;
    }

    clearTimeout(this.timeOutID);
    this.timeOutID = setTimeout(() => {
      this.zipCodeList = []
      this.master.post('readLocationByZipcode', { zipcode: this.addressLookup['zipcode'] }, res => {
        if (res) {
          // check if API conecction success
          if (res.status == 200) {
            // * success
            this.zipCodeList = res.data.locations
            // autocomplete
            // if (this.addressLookup['zipcode'].length >= 5) {
            //   this.selectReference(this.zipCodeList[0])
            // }
          }
        } else {
          this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
        }
      })
    }, 750);

    /**/
  }

  // set the address exist
  private selectReference = (address: Object): void => {
    // set address lockup only view
    this.addressLookup['city'] = address['city']
    this.addressLookup['state'] = address['state']
    this.addressLookup['county'] = address['county']
    this.addressLookup['zipcode'] = address['zipcode']
    this.addressLookup['country'] = 'United States'
    // set address for formuler
    this.information.value['city'] = address['city']
    this.information.value['state'] = address['state']
    this.information.value['county'] = address['county']
    this.information.value['zipCode'] = address['zipcode']
    this.information.value['country'] = 'United States'

    this.zipCodeList = []
  }

  // open the location
  private openLocation = (address: string, county: string, state: string): void => {
    address = address.replace(' ', '+')
    county = county.replace(' ', '+')
    state = state.replace(' ', '+')
    console.info(`https://www.google.com/maps/search/?api=1&query=${address}+${county}+${state}`);

    window.open(`https://www.google.com/maps/search/?api=1&query=${address}+${county}+${state}`, '_blank')
  }

  /*
  * Life cicles
  */
  constructor(private master: MasterService, private ms: MessageService, private route: ActivatedRoute) {
    this.type = this.route.snapshot.params['type']
  }

  ngOnInit() {
    // assign the new default on listener
    this.navbarWatcher = this.ms.channelComponents$.subscribe(res => {

      if (res.message == "changeLenguage") {
        this.language = res.value
        return
      }

      if (res.message == 'individualValue') {
        this.isIndividual = res.value
        return
      }
    })
    
    // assign the new default
    // this.addressesList = this.contact['addresses']
    // if (this.addressesList.length > 0) {
    //   let object = this.addressesList.filter(el => el['primaryAddress'] == 1)

    //   if (object.length > 0) {
    //     this.selected = object[0]
    //   } else {
    //     this.selected = { address: 'none' }
    //   }
    // }
    // clean the form
    this.cleanFields()
  }

  ngOnDestroy() {
    if (!this.navbarWatcher) {
      return
    }

    this.navbarWatcher.unsubscribe()
  }
}
